import { NETWORKS } from '../constants/networks';
import { ENV } from '../constants/environment';

export class NetworkManager {
    static getTargetNetwork() {
        const network = NETWORKS[ENV.NETWORK_MODE];
        if (!network) {
            throw new Error(`Invalid network mode: ${ENV.NETWORK_MODE}`);
        }
        return network;
    }

    static isValidNetwork(chainId) {
        const targetNetwork = this.getTargetNetwork();
        return chainId === targetNetwork.chainId;
    }
}